import React from 'react'; //eslint-disable-line
import { gsap } from 'gsap'; //eslint-disable-line
import { CSSPlugin } from 'gsap/CSSPlugin';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';

import Selection from './pages/Home';
import HeaderContainer from './containers/HeaderContainer';
import FooterContainer from './containers/FooterContainer';
import MainContainer from './containers/MainContainer';
import HubConnection from './utils/signalr/index';
import StationDeparture from './pages/StationDeparture';
import UnionDeparture from './pages/UnionDeparture';
import TripDetail from './pages/TripDetail';
import UnionTripDetail from './pages/UnionTripDetail';
import Menu from './components/Menu';
import { locationStore } from './stores/locationStore';
import { viewStore } from './stores/viewStore';
import goTrackerConfig from 'goTrackerConfig'; //eslint-disable-line
import MessageBanner from './components/MessageBanner';
import BusDeparture from './pages/BusDeparture';
import BusTripDetail from './pages/BusTripDetail';
import UsbtDeparture from './pages/UsbtDeparture';
import utils from './utils';


// Force CSSPlugin to not get dropped during build
gsap.registerPlugin(CSSPlugin);

const calcMobileViewHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

calcMobileViewHeight();

window.addEventListener('resize', calcMobileViewHeight);

/* eslint-disable */
const startSignalR = () => {
  HubConnection({
    locationStore,
    callbacks: {
      send: message => {
        toast(<Toast message={message} />, defaultToastStyle);
      },
      stopCancelled: () => {},
    },
    onConnected: () => {
      console.log('CONNECTED to signalr');
    },
    onDisconnected: () => {
      console.log('DISCONNECTED to signalr');
    },
  });
};

const startApplication = async () => {
  utils.showApplicationVersion();
  viewStore.startLocalForage();

  await locationStore.loadData();
  viewStore.getViewSettings();
  viewStore.loadLastCorridorAndStation();

  if (goTrackerConfig.disableSignalr === true) {
    return;
  }

  startSignalR();
};

startApplication();

class App extends React.Component {
  render() {
    return (
      <React.Fragment>
        <MainContainer>
          <BrowserRouter basename={`${goTrackerConfig.prefix}`}>
            <HeaderContainer />
            <MessageBanner />
            <Switch>
              <Route exact path="/UnionDeparture/:corridor/:station" render={(props) =>
                <UnionDeparture corridor={props.match.params.corridor} station={props.match.params.station} />
              } />
              <Route exact path="/USBTDeparture/:corridor/:station" render={(props) => {
                return goTrackerConfig.showBusTerminals ? (
                  <UsbtDeparture corridor={props.match.params.corridor} station={props.match.params.station} isUnionStButton={props.match.params.isUnionStButton} />
                ) : (
                  <Redirect exact from="/USBTDeparture/:corridor/:station" to="/" />
                )
              }} />
              <Route exact path="/BusDeparture/:corridor/:station" render={(props) => {
                return goTrackerConfig.showBusTerminals ? (
                  <BusDeparture corridor={props.match.params.corridor} station={props.match.params.station} isUnionStButton={props.match.params.isUnionStButton} />
                ) : (
                  <Redirect exact from="/BusDeparture/:corridor/:station" to="/" />
                )
              }} />
              <Route exact path="/StationDeparture/:corridor/:station" render={(props) =>
                <StationDeparture corridor={props.match.params.corridor} station={props.match.params.station} />
              } />
              <Route exact path="/UnionDeparture/:corridor/:station/TripDetail/:tripNumber" render={(props) =>
                <UnionTripDetail params={props.match.params} />
              } />
              <Route exact path="/StationDeparture/:corridor/:station/TripDetail/:tripNumber" render={(props) =>
                <TripDetail params={props.match.params} />
              } />
              <Route exact path="/BusDeparture/:corridor/:station/BusTripDetail/:tripNumber" render={(props) => {
                return goTrackerConfig.showBusTerminals ? (
                  <BusTripDetail params={props.match.params} />
                ) : (
                  <Redirect exact from="/BusDeparture/:corridor/:station/BusTripDetail/:tripNumber" to="/" />
                )
              }} />
              <Route exact path="/" render={() => <Selection />} />
              {/*catch all paths that cannot be matched*/}
              <Route path="*" render={() => <Selection />} />
            </Switch>
            <FooterContainer />
          </BrowserRouter>
        </MainContainer>
        <Menu />
      </React.Fragment>
    );
  }
}

export default App;
